'use client';

import { isValidUUID } from '@dte/otw-utils-validation/src/isValidUUID';
import { useValidatedStringQueryParam } from '../../../../hooks/parameters/useValidatedStringQueryParam';

export function useReportIdParam(): string | undefined {
	return useValidatedStringQueryParam('reportId', isValidUUID);
}
